/**
 * @param preferenceCenter {HTMLElement}
 * @return {boolean}
 */
module.exports = function PreferenceCenter_areAllOptionsDisabled(preferenceCenter) {
    let allDisabled = true;

    preferenceCenter.querySelectorAll('[type="checkbox"]').forEach(checkbox => {
        if (
            checkbox instanceof HTMLInputElement &&
            checkbox.checked &&
            !["marketingConsent", "unsubscribeAll", "subscribeAll"].includes(checkbox.name)
        ) {
            allDisabled = false;
        }
    });

    return allDisabled;
}